var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"ModalBody"},[_c('SimpleForm',{attrs:{"autofocus":true,"onSubmit":_vm.onSubmit,"fields":[
				{
					label : 'Organisation name',
					name : 'name',
					autocomplete : 'company_name',
					autofocus : true,
					required : true,
				} ]}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ModalPrompt"},[_c('h1',[_vm._v("Add org")])])}]

export { render, staticRenderFns }